





















































import {User} from 'firebase';
import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {Action, Getter, State} from 'vuex-class';
import BUpload from 'buefy/src/components/upload/Upload.vue'; // @ is an alias to /src
import BField from 'buefy/src/components/field/Field.vue'; // @ is an alias to /src
import BDropdown from 'buefy/src/components/dropdown/Dropdown.vue';
import BDropdownItem from 'buefy/src/components/dropdown/DropdownItem.vue';
import BSelect from 'buefy/src/components/select/Select.vue';
import BRadio from 'buefy/src/components/radio/Radio.vue';
import {MAFUser} from '@/store/User/types';
import * as _ from 'lodash';
import {RadioAvatar, RadioAvatarOption} from '@/components/common/types';
import RadioButton from '@/components/common/RadioButton.vue';
import { UserTransaction } from '../../store/User/types';

const namespace = 'userState';

@Component({
    components: {
        RadioButton,
        BSelect,
        BField,
        BButton,
        BUpload,
        BRadio,
    },
})
/* tslint:disable:max-line-length */
export default class AvatarCreator extends Vue {
    @State('currentUser') public currentUser: User | undefined;
    @Prop() public readonly self!: MAFUser;
    @Action('updateUser', {namespace}) public updateUser: any;
    @State('transactions', {namespace}) public readonly transactions!: UserTransaction[];

    public updateUserWAvatar: MAFUser;
    public options: string;
    public isLoading: boolean;
    public optionArray: RadioAvatar[];
    public currentOptionIndex: number;
    public currentOption: RadioAvatar;
    public currentSelected: RadioAvatarOption | null;
    public skin: RadioAvatarOption | null;
    public top: RadioAvatarOption | null;
    public hatColor: RadioAvatarOption | null;
    public hairColor: RadioAvatarOption | null;
    public accessories: RadioAvatarOption | null;
    public facialHair: RadioAvatarOption | null;
    public facialHairColor: RadioAvatarOption | null;
    public clothes: RadioAvatarOption | null;
    public eyes: RadioAvatarOption | null;
    public eyebrow: RadioAvatarOption | null;
    public mouth: RadioAvatarOption | null;
    public clothesColor: RadioAvatarOption | null;
    public BASE_URL: string = process.env.BASE_URL ? process.env.BASE_URL : '';

    public baseAvataarUrl: string = 'https://avatars.dicebear.com/v2/avataaars/';
    public seed: string | undefined;
    public style: string = 'circle';
    public selectedFilter: string = 'longHair';

    constructor() {
        super();
        this.updateUserWAvatar = this.self;
        this.seed = 'test';
        this.clothesColor = null;
        this.skin = null;
        this.top = null;
        this.hatColor = null;
        this.hairColor = null;
        this.accessories = null;
        this.facialHair = null;
        this.facialHairColor = null;
        this.clothes = null;
        this.eyes = null;
        this.eyebrow = null;
        this.mouth = null;
        this.isLoading = false;
        this.optionArray = [
          {
            chance: '',
            display: 'Skin',
            type: 'skin',
            prompt: 'choose a skin tone',
            options: [
              { selected: false,  option: 'tanned',     disabled: false,  inactive_btn: 'btn_tan_inactive.png',     active_btn: 'btn_tan_active.png' },
              { selected: false,  option: 'yellow',     disabled: false,  inactive_btn: 'btn_yel_inactive.png',     active_btn: 'btn_yel_active.png' },
              { selected: false,  option: 'pale',       disabled: false,  inactive_btn: 'btn_pal_inactive.png',     active_btn: 'btn_pal_active.png' },
              { selected: true,   option: 'light',      disabled: false,  inactive_btn: 'btn_lig_inactive.png',     active_btn: 'btn_lig_active.png' },
              { selected: false,  option: 'brown',      disabled: false,  inactive_btn: 'btn_bro_inactive.png',     active_btn: 'btn_bro_active.png' },
              { selected: false,  option: 'darkBrown',  disabled: false,  inactive_btn: 'btn_drkbro_inactive.png',  active_btn: 'btn_drkbro_active.png' },
              { selected: false,  option: 'black',      disabled: false,  inactive_btn: 'btn_bla_inactive.png',     active_btn: 'btn_bla_active.png' },
            ],
          },
          {
            chance: '',
            display: 'Top',
            type: 'top',
            prompt: 'choose a hair type, hat, etc.',
            options: [
              // long hair
              { selected: true,   seed: 'test',   label: 'Default',             option: 'longHair+',                            disabled: false, inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: true,   seed: 'flow',   label: 'Straightened',        option: 'shortHair,longHair',                   disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'fl',     label: 'Curly',               option: 'longHair,shortHair,eyepatch,hat',      disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'anna',   label: 'Fro',                 option: 'longHair,shortHair,turban',            disabled: false, inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'anna',   label: 'Fro & Headband',      option: 'longHair,shortHair,turban,hijab',      disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: true,   seed: 'flows',  label: 'Flowy',               option: 'longHair',                             disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: true,   seed: 'anna',   label: 'Curvy',               option: 'longHair,turban',                      disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: true,   seed: 'anna',   label: 'Frida Hair',          option: 'longHair,hat,hijab,turban',            disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: true,   seed: 'anna',   label: 'Dreads',              option: 'longHair,hat,hijab',                   disabled: false, inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: true,   seed: 'poppy',  label: 'Shaved Sides',        option: 'longHair,hijab,turban',                disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              // medium hair
              { selected: true,   seed: 'test',   label: 'Bangs',               option: 'longHair,hijab,turban',                disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: true,   seed: 'poppy',  label: 'Medium Length',       option: 'longHair,hijab',                       disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'flows',  label: 'Bob',                 option: 'longHair,shortHair',                   disabled: false, inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: true,   seed: 'anna',   label: 'Mia Wallace',         option: 'longHair,shortHair,hat,hijab,turban',  disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'fl',     label: 'Curly',               option: 'longHair,shortHair,eyepatch,hat',      disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'annf',   label: 'Bun',                 option: 'longHair,shortHair,turban',            disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              // short hair
              { selected: false,  seed: 'test',   label: 'Caesar',              option: 'shortHair+',                               disabled: false,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'test',   label: 'Caesar Side Part',    option: 'shortHair,eyepatch',                       disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'poppy',  label: 'Round',               option: 'longHair,shortHair,hat,turban',            disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'flow',   label: 'Dreads1',             option: 'longHair,shortHair,eyepatch,hat',          disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'flow',   label: 'Dreads2',             option: '',                                         disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'bett',   label: 'Frizzle',             option: 'shortHair',                                disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'poppy',  label: 'Mullet',              option: 'longHair,shortHair,eyepatch,turban',       disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'poppy',  label: 'Curly',               option: 'longHair,shortHair,eyepatch,hijab,turban', disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'poppy',  label: 'Flat',                option: 'longHair,shortHair,hat',                   disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'test',   label: 'Waved',               option: 'shortHair,longHair',                       disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'test',   label: 'Side Hair',           option: 'longHair,shortHair,eyepatch',              disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              // hats
              { selected: false,  seed: 'test',   label: 'Eyepatch',            option: 'eyepatch',                             disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'test',   label: 'Hat',                 option: 'shortHair,longHair,hat',               disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'test',   label: 'Hijab',               option: 'hijab',                                disabled: false,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'test',   label: 'Turban',              option: 'turban',                               disabled: false,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'test',   label: 'Winter (Ear Flaps)',  option: 'longHair,shortHair,hat,hijab',         disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'test',   label: 'Winter (Tassles)',    option: 'longHair,hat',                         disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'test',   label: 'Winter (Pom Pom)',    option: 'longHair,hat,hijab',                   disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  seed: 'test',   label: 'Winter (Cat Ears)',   option: 'hat',                                  disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
            ],
          },
          {
            chance: '',
            display: 'Hat Color',
            type: 'hatColor',
            prompt: 'choose a color for your hat',
            options: [
              { selected: true,  label: 'Black',    option: 'black',    disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false, label: 'Blue',     option: 'blue',     disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false, label: 'Gray',     option: 'gray',     disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false, label: 'Pink',     option: 'pink',     disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false, label: 'Red',      option: 'red',      disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false, label: 'White',    option: 'white',    disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false, label: 'Heather',  option: 'heather',  disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false, label: 'Pastel',   option: 'pastel',   disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
            ],
          },
          {
            chance: '',
            display: 'Hair Color',
            type: 'hairColor',
            prompt: 'choose a color for your hair',
            options: [
              { selected: false,  label: 'Black',     option: 'black',    disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: true,   label: 'Auburn',    option: 'auburn',   disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Brown',     option: 'brown',    disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Blonde',    option: 'blonde',   disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Platinum',  option: 'platinum', disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Red',       option: 'red',      disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Pastel',    option: 'pastel',   disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Gray',      option: 'gray',     disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
            ],
          },
          {
            display: 'Accessories',
            type: 'accessories',
            chance: '&options[accessoriesChance]=100',
            prompt: 'choose your accessories',
            options: [
              { selected: true,   label: 'None',                  option: 'none',           disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Prescription Gray',     option: 'prescription01', disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Prescription Black',    option: 'prescription02', disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Prescription Round',    option: 'round',          disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Fancy Sunglasses',      option: 'kurt',           disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Sunglasses',            option: 'sunglasses',     disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Wayfarers',             option: 'wayfarers',      disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
            ],
          },
          {
            chance: '&options[facialHairChance]=100',
            display: 'Facial Hair',
            type: 'facialHair',
            prompt: 'choose your facial hair',
            options: [
              { selected: true,   label: 'None',      option: 'none',     disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Light',     option: 'light',    disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: true,   label: 'Medium',    option: 'medium',   disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Majestic',  option: 'majestic', disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Fancy',     option: 'fancy',    disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Magnum',    option: 'magnum',   disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
            ],
          },
          {
            chance: '',
            display: 'Facial Hair Color',
            type: 'facialHairColor',
            prompt: 'choose your facial hair color',
            options: [
              { selected: true,   label: 'Auburn',    option: 'auburn',   disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Black',     option: 'black',    disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Blonde',    option: 'blonde',   disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Brown',     option: 'brown',    disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Platinum',  option: 'platinum', disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Red',       option: 'red',      disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
            ],
          },
          {
            chance: '',
            display: 'Clothes',
            type: 'clothes',
            prompt: 'choose your clothes',
            options: [
              { selected: true,   label: 'Blazer',          option: 'blazer',           disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: true,   label: '*Blazer Sweater', option: 'blazer,sweater',   disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Sweater',         option: 'sweater',          disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Shirt',           option: 'shirt',            disabled: false,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: '*Scoop Neck',     option: 'shirt,hoodie',     disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: '*Graphic Tee',    option: 'blazer,shirt',     disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Hoodie',          option: 'hoodie',           disabled: false,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Overall',         option: 'overall',          disabled: true,    inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
            ],
          },
          {
            chance: '',
            display: 'Clothes Color',
            type: 'clothesColor',
            prompt: 'choose your clothes color',
            options: [
              { selected: true,   label: 'Black',         option: 'black',            disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Blue',          option: 'blue',             disabled: false,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              // { selected: false,  label: 'Sky Blue',      option: 'black,blue',     disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Heather Blue',  option: 'blue,heather,red', disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Heather',       option: 'heather',          disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Gray',          option: 'gray',             disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Dark Gray',     option: 'gray,heather',     disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              // { selected: false,  label: 'Pastel',  option: 'pastel',   disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              // { selected: false,  label: 'Pastel Blue',   option: 'pastel,blue',      disabled: false,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              // { selected: false,  label: 'Pastel Green',  option: 'pastel,heather',   disabled: false,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              // { selected: false,  label: 'Pastel Red',    option: 'pastel,red',       disabled: false,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Pink',          option: 'pink',             disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Red',           option: 'red',              disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'White',         option: 'white',            disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
            ],
          },
          {
            chance: '',
            display: 'Eyes',
            type: 'eyes',
            prompt: 'choose your eyes',
            options: [
              { selected: true,   label: 'Default',       option: 'defaultValue',   disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: true,   label: 'Close',         option: 'close',          disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              // { selected: false,  label: 'Cry',           option: 'cry',            disabled: false,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              // { selected: false,  label: 'Dizzy',         option: 'dizzy',          disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Roll',          option: 'roll',           disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Happy',         option: 'happy',          disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Hearts',        option: 'hearts',         disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Side',          option: 'side',           disabled: false,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Squint',        option: 'squint',         disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Surprised',     option: 'surprised',      disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Wink Right ',   option: 'wink',           disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Wink Left',     option: 'winkWacky',      disabled: true,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
            ],
          },
          {
            chance: '',
            display: 'Eyebrow',
            type: 'eyebrow',
            prompt: 'choose your eyebrows',
            options: [
              { selected: false,  label: 'Default',   option: 'defaultValue', disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Flat',      option: 'flat',         disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Raised',    option: 'raised',       disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Up',        option: 'up',           disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Sad',       option: 'sad',          disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: true,   label: 'Angry',     option: 'angry',        disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Unibrow',   option: 'unibrow',      disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
            ],
          },
          {
            chance: '',
            display: 'Mouth',
            type: 'mouth',
            prompt: 'choose your mouth',
            options: [
              { selected: false,  label: 'Default',     option: 'defaultValue',   disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Smile',       option: 'smile',          disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Tongue',      option: 'tongue',         disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: true,   label: 'Concerned',   option: 'concerned',      disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Disbelief',   option: 'disbelief',      disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Eating',      option: 'eating',         disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Grimace',     option: 'grimace',        disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Sad',         option: 'sad',            disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Scream',      option: 'scream',         disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Serious',     option: 'serious',        disabled: false,  inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              { selected: false,  label: 'Twinkle',     option: 'twinkle',        disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' },
              // { selected: false,  label: 'Vomit',       option: 'vomit',          disabled: true,   inactive_btn: 'btn_reg_inactive.png', active_btn: 'btn_reg_active.png' }
            ],
          },
        ];
        this.currentOptionIndex = 0;
        this.currentOption = this.optionArray[this.currentOptionIndex];
        this.currentSelected = this.currentOption.options[0];
        this.options = `https://avatars.dicebear.com/v2/avataaars/${this.seed}.svg?options[style]=${this.style}&options[${this.currentOption.type}][]=${this.currentSelected.option}${this.currentOption.chance}`;
    }

    public created() {
      if (this.self.avataarUrl) {
        this.options = this.self.avataarUrl;

        // setting properties from "Change Profile" creator
        this.setProperty('skin');
        this.setProperty('top');
        this.setProperty('hatColor');
        this.setProperty('hairColor');
        this.setProperty('accessories');
        this.setProperty('facialHair');
        this.setProperty('facialHairColor');
        this.setProperty('clothes');
        this.setProperty('clothesColor');
        this.setProperty('eyes');
        this.setProperty('eyebrow');
        this.setProperty('mouth');
      }

      if (this.self.first500 && this.hasFirst500) {
        // if they're one of the first 500 && they've redeemed, unlock the items
        this.unlockFirst500();
      }
    }

    get radioOptions() {
      if (this.currentOption.display === 'Top') {
        switch (this.selectedFilter) {
          case 'longHair':
            return this.currentOption.options.slice(0, 10);
          case 'mediumHair':
            return this.currentOption.options.slice(10, 16);
          case 'shortHair':
            return this.currentOption.options.slice(16, 27);
          case 'hats':
            return this.currentOption.options.slice(27, 35);
        }
      } else {
        return this.currentOption.options;
      }
    }

    get hasFirst500() {
        const hasFirst500 = _.find(this.transactions, (t: UserTransaction) => t.purchase.what === 'first500');
        return !!hasFirst500;
    }

    public setFilter( filter: string ) {
      this.selectedFilter = filter;
    }

    public setProperty(prop: string) {
      const name = this.getParameterByName(`options[${prop}][]`, this.self.avataarUrl);
      const skinObj = _.find(this.optionArray, {type: prop});
      if (skinObj && name) {
          const found = _.find(skinObj.options, {option: name});
          if (found) {
              if (prop === 'skin') {
                  this.currentSelected = found;
              }
              // @ts-ignore
              this[prop] = found;
          }
      }
    }

    public getParameterByName(name: any, url: any) {
        const query = url.split('?')[1];
        const vars = query.split('&');
        for (const p of vars) {
            const pair = p.split('=');
            if (pair[0] === name) {return pair[1]; }
        }
        // test
        return false;
    }

    @Watch('currentSelected', {deep: true})
    public updateOptions() {
        let opt = '';
        // @ts-ignore
        this[this.currentOption.type] = null;
        if (this.currentSelected && this.currentSelected.option === 'none') {
          if (this.currentOption.type === 'accessories') {
            // "no accessories" selected which can be weird for these seeds
            opt = `https://avatars.dicebear.com/v2/avataaars/${this.seed}.svg?options[style]=${this.style}&options[accessoriesChance]=0`;
          } else {
            opt = `https://avatars.dicebear.com/v2/avataaars/${this.seed}.svg?options[style]=${this.style}`;
          }
        } else if (this.currentSelected) {
          let options = '';
          // hair, hat, etc.
          if (this.currentOption.type === 'top' || this.currentOption.type === 'clothes' || this.currentOption.type === 'clothesColor') {
            if (this.currentSelected.option !== '') {
              this.seed = (this.currentOption.type === 'top') ? this.currentSelected.seed : this.seed;
              const topOptions = this.currentSelected.option.split(',');
              topOptions.forEach((top) => {
                options += `&options[${this.currentOption.type}][]=${top.replace('+', '')}`;
              });
            }
          } else {
            options = `&options[${this.currentOption.type}][]=${this.currentSelected ? this.currentSelected.option.replace('+', '') : ''}${this.currentOption.chance}`;
          }

          opt = `https://avatars.dicebear.com/v2/avataaars/${this.seed}.svg?options[style]=${this.style}${options}`;
        }
        if (this.skin) {
            opt += `&options[skin][]=${this.skin.option}`;
        }
        if (this.top) {
          if (this.top.option.includes(',')) {
            const topOptions = this.top.option.split(',');
            topOptions.forEach((t) => {
              opt += `&options[top][]=${t.replace('+', '')}`;
            });
          } else {
            opt += `&options[top][]=${this.top.option.replace('+', '')}`;
          }
        }
        if (this.hairColor) {
            opt += `&options[hairColor][]=${this.hairColor.option}`;
        }
        if (this.hatColor) {
            opt += `&options[hatColor][]=${this.hatColor.option}`;
        }
        if (this.accessories) {
            if (this.accessories.option !== 'none') {
                opt += `&options[accessoriesChance]=100&options[accessories][]=${this.accessories.option}`;
            } else {
              opt += `&options[accessoriesChance]=0`;
            }
        }
        if (this.facialHair) {
            if (this.facialHair.option !== 'none') {
                opt += `&options[facialHairChance]=100&options[facialHair][]=${this.facialHair.option}`;
            }
        }
        if (this.facialHairColor) {
            opt += `&options[facialHairColor][]=${this.facialHairColor.option}`;
        }
        if (this.clothes) {
          if (this.clothes.option.includes(',')) {
            const clothesOptions = this.clothes.option.split(',');
            clothesOptions.forEach((c) => {
              opt += `&options[clothes][]=${c}`;
            });
          } else {
            opt += `&options[clothes][]=${this.clothes.option}`;
          }
        }
        if (this.clothesColor) {
          if (this.clothesColor.option.includes(',')) {
            const clothesColors = this.clothesColor.option.split(',');
            clothesColors.forEach((c) => {
              opt += `&options[clothesColor][]=${c}`;
            });
          } else {
            opt += `&options[clothesColor][]=${this.clothesColor.option}`;
          }
        }
        if (this.eyes) {
            opt += `&options[eyes][]=${this.eyes.option}`;
        }
        if (this.eyebrow) {
            opt += `&options[eyebrow][]=${this.eyebrow.option}`;
        }
        if (this.mouth) {
            opt += `&options[mouth][]=${this.mouth.option}`;
        }
        this.options = opt;

    }


    public moveCurrentSelected(direction: number) {
        if (direction > 0) {
            if (this.currentOptionIndex < this.optionArray.length - 1) {
                this.setSelectedOnMove();
                this.currentOptionIndex += direction;
                this.currentOption = this.optionArray[this.currentOptionIndex];
                // @ts-ignore
                // this[this.currentOption.type] = null;
                this.setNewSelectedOnMove();
            }
        } else {
            if (this.currentOptionIndex > 0) {
                this.setSelectedOnMove();
                this.currentOptionIndex += direction;
                this.currentOption = this.optionArray[this.currentOptionIndex];
                // @ts-ignore
                // this[this.currentOption.type] = null;
                this.setNewSelectedOnMove();
            }
        }

    }

    public setNewSelectedOnMove() {
        switch (this.currentOption.display) {
            case'Skin':
                this.currentSelected = this.skin ? this.skin : this.currentOption.options[0];
                break;
            case'Top':
                this.currentSelected = this.top ? this.top : this.currentOption.options[0];
                break;
            case'Hat Color':
                this.currentSelected = this.hatColor ? this.hatColor : this.currentOption.options[0];
                break;
            case'Hair Color':
                this.currentSelected = this.hairColor ? this.hairColor : this.currentOption.options[0];
                break;
            case'Accessories':
                this.currentSelected = this.accessories ? this.accessories : this.currentOption.options[0];
                break;
            case'Facial Hair':
                this.currentSelected = this.facialHair ? this.facialHair : this.currentOption.options[0];
                break;
            case'Facial Hair Color':
                this.currentSelected = this.facialHairColor ? this.facialHairColor : this.currentOption.options[0];
                break;
            case'Clothes':
                this.currentSelected = this.clothes ? this.clothes : this.currentOption.options[0];
                break;
            case'Clothes Color':
                this.currentSelected = this.clothesColor ? this.clothesColor : this.currentOption.options[0];
                break;
            case'Eyes':
                this.currentSelected = this.eyes ? this.eyes : this.currentOption.options[0];
                break;
            case'Eyebrow':
                this.currentSelected = this.eyebrow ? this.eyebrow : this.currentOption.options[0];
                break;
            case'Mouth':
                this.currentSelected = this.mouth ? this.mouth : this.currentOption.options[0];
                break;
        }
    }

    public setSelectedOnMove() {
        switch (this.currentOption.display) {
            case'Skin':
                this.skin = this.currentSelected;
                break;
            case'Top':
                this.top = this.currentSelected;
                break;
            case'Hat Color':
                this.hatColor = this.currentSelected;
                break;
            case'Hair Color':
                this.hairColor = this.currentSelected;
                break;
            case'Accessories':
                this.accessories = this.currentSelected;
                break;
            case'Facial Hair':
                this.facialHair = this.currentSelected;
                break;
            case'Facial Hair Color':
                this.facialHairColor = this.currentSelected;
                break;
            case'Clothes':
                this.clothes = this.currentSelected;
                break;
            case'Clothes Color':
                this.clothesColor = this.currentSelected;
                break;
            case'Eyes':
                this.eyes = this.currentSelected;
                break;
            case'Eyebrow':
                this.eyebrow = this.currentSelected;

                break;
            case'Mouth':
                this.mouth = this.currentSelected;

                break;
        }
    }

    // public unselect(event: Event) {
    //     this.currentSelected = null;
    //     // @ts-ignore
    //     this[this.currentOption.type] = null;
    // }

    public unlockFirst500() {
      // hat
      this.optionArray[1].options[1].disabled = false;
      this.optionArray[1].options[4].disabled = false;
      this.optionArray[1].options[11].disabled = false;
      this.optionArray[1].options[25].disabled = false;
      this.optionArray[1].options[32].disabled = false;

      // hair color
      this.optionArray[3].options[1].disabled = false;

      // accessories
      this.optionArray[4].options[4].disabled = false;
      this.optionArray[4].options[6].disabled = false;

      // facial hair
      this.optionArray[5].options[2].disabled = false;
      this.optionArray[5].options[3].disabled = false;

      // facial hair color
      this.optionArray[6].options[0].disabled = false;

      // shirt
      this.optionArray[7].options[1].disabled = false;
      this.optionArray[7].options[2].disabled = false;

      // shirt color
      this.optionArray[8].options[7].disabled = false;

      // eyes
      this.optionArray[9].options[4].disabled = false;
      this.optionArray[9].options[6].disabled = false;
      this.optionArray[9].options[8].disabled = false;

      // eyebrows
      this.optionArray[10].options[3].disabled = false;

      // mouth
      this.optionArray[11].options[2].disabled = false;
      this.optionArray[11].options[6].disabled = false;
    }

    public async submit() {
        this.isLoading = true;
        this.updateUserWAvatar.imageURL = '';
        this.updateUserWAvatar.userUploadedImage = false;
        this.updateUserWAvatar.avataarUrl = this.options;
        if (!this.updateUserWAvatar.Reference) {
            const userDocumentRef = Vue.prototype.$firestore.collection('users').doc(this.updateUserWAvatar.uid);
            this.updateUserWAvatar.setDocumentReference(userDocumentRef);
        }
        try {
                await this.updateUser(this.updateUserWAvatar);
                } catch (e) {
            this.$snackbar.open({
                    message: 'Error saving user please try again.',
                    type: 'is-danger',
                    indefinite: true,
                });
        }
        this.isLoading = false;
        // @ts-ignore
        this.$parent.close();
    }

}
